"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _useNearestPickupPointsQuery = require("../../api/useNearestPickupPointsQuery");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _DeliveryBox = _interopRequireDefault(require("../DeliveryBox/DeliveryBox"));
var _FormattedMessage = require("../FormattedMessage");
var _Skeleton = require("../Skeleton");
var _shared = require("../shared");
var _NoResultsMessage = require("./NoResultsMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  ..._shared.scrollingContainerStyles,
  padding: theme.spacing(0, 4, 2)
}));
const Title = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    isMapAvailable
  }
}) => ({
  marginBottom: theme.spacing(3),
  ...(isMapAvailable && {
    marginTop: theme.spacing(5)
  })
}));
const NearestOptionsTitle = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: theme.spacing(5, 0, 3)
}));
const NearestPickupPoints = ({
  instantResultChannelId,
  instantSearchTerm,
  isMapAvailable,
  onPickupPointItemConfirmation
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const [selectedDeliveryChannelId, setSelectedDeliveryChannelId] = (0, _react.useState)(undefined);
  const {
    nearestPickupPointsResult,
    isNearestPickupPointsResultLoading
  } = (0, _useNearestPickupPointsQuery.useNearestPickupPointsQuery)(instantResultChannelId, setSelectedDeliveryChannelId, selectedDeliveryChannelId);
  const {
    pickup,
    nearPickups
  } = nearestPickupPointsResult ?? {};
  const {
    deliveryChannelId,
    cvId
  } = pickup ?? {};
  const {
    isAddingNewDelivery
  } = (0, _hooks.useAnalytics)();
  const pickupDeliveryBoxProps = {
    boxName: 'instant-result-pickup-point',
    isActive: deliveryChannelId === selectedDeliveryChannelId,
    isButtonConfirmationEnabled: true,
    // analytics
    metaHierarchy: [_models.MetaHierarchy.DeliverySelection, isAddingNewDelivery.current ? _models.MetaHierarchy.FirstSelection : _models.MetaHierarchy.EditSelection, _models.MetaHierarchy.New, _models.MetaHierarchy.PickUpPoint, _models.MetaHierarchy.ListSearch],
    onDeliveryItemActivation: onPickupPointItemConfirmation,
    setSelectedDeliveryChannelId
  };
  const ownerState = {
    isMapAvailable
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    ...getTestIdProps(_models.TestId.NearestPickupPointsContainer),
    children: [isNearestPickupPointsResultLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.NearestPickupPointsSkeleton, {}) : null, !isNearestPickupPointsResultLoading && nearestPickupPointsResult ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [!pickup && !nearPickups && instantSearchTerm ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoResultsMessage.NoResultsMessage, {
        searchTerm: instantSearchTerm
      }) : null, pickup ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Title, {
          ownerState: ownerState,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            variant: "h6",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
              id: "results"
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryBox.default, {
          deliveryItem: pickup,
          ...pickupDeliveryBoxProps
        }, cvId)]
      }) : null, nearPickups ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(NearestOptionsTitle, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            variant: "h6",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
              id: "nearestOptions"
            })
          })
        }), nearPickups.map(nearPickup => {
          const {
            cvId: nearPickupCvId,
            deliveryChannelId: nearPickupChannelId
          } = nearPickup;
          const nearPickupDeliveryBoxProps = {
            ...pickupDeliveryBoxProps,
            boxName: 'near-pickup-point',
            deliveryItem: nearPickup,
            isActive: nearPickupChannelId === selectedDeliveryChannelId
          };
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryBox.default, {
            ...nearPickupDeliveryBoxProps
          }, nearPickupCvId);
        })]
      }) : null]
    }) : null]
  });
};
var _default = exports.default = NearestPickupPoints;